
import { ILockscreenNfcBadge, LockScreenService } from "@/services/lockscreen-service";
import AppAddModal from "./LockScreenAddNfcBadgeModal.vue";
import AppLockScreenSettingsModal from "./LockScreenSettingsModal.vue";
import AppLockScreenNfcBadgesEditModal from "./LockScreenNfcBadgeEditModal.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			addBadgeModal: false,
			settingsModal: false,
			badges: [] as ILockscreenNfcBadge[],
			toEditBadge: null as null | ILockscreenNfcBadge
		};
	},
	computed: {
		isEnabled():boolean {
			//			return BrowserInfo.isElectron();
			return true;
		},
		addDisabled():boolean{
			return this.badges.length >= LockScreenService.MAX_BADGES;
		}
	},
	methods: {
		addClicked(){
			this.addBadgeModal = true;
		},
		async refresh(){
			let storedBadges = this.badges;
			let result = await LockScreenService.getNfcBadges();
			for (let item of result){
				for (let stored of storedBadges){
					if (item.ID == stored.ID){
						item.Uid = stored.Uid;
					}
				}
			}
			this.badges = result;
		},
		async deleteBadge(badge:ILockscreenNfcBadge){
			let confirm = await this.$confirmBuilder(this.$ct("are-you-sure-you-want-to-delete-badge", {label: badge.Label})).setWarningTitle().show();
			if (!confirm) return;
			await LockScreenService.deleteNfcBadge(badge.ID);
			this.refresh();
		},
		editBadge(badge:ILockscreenNfcBadge){
			this.toEditBadge = badge;
		}
	},
	mounted(){
		this.refresh();
	},
	components: {
		AppAddModal,
		AppLockScreenSettingsModal,
		AppLockScreenNfcBadgesEditModal
	},
	i18nEx: {
		componentPrefix: "components.LockScreen"
	}
});
